import { useEffect, useRef } from 'react'

import { IconLoading } from '@/assets/icons/icon-loading'
import SearchIcon from '@/assets/icons/icon-search.svg'
import { TextField } from '@/components/ui/text-field'
import ChevronDownIcon from '@/modules/chatting/icons/chevron-down.svg'

import { IconButton } from '../components/icon-button'

interface Props<T> {
  isSearching: boolean
  results?: Nullable<T[]>
  handleSearchChange: (val: string) => void
  value: string
  shownResultIndex: number
  onNext: (index: T) => void
  onPrev: (index: T) => void
}

export const SearchField = <T,>({
  isSearching,
  results,
  handleSearchChange,
  value,
  shownResultIndex,
  onNext,
  onPrev,
}: Props<T>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearchChange(event.target.value)
  }
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <TextField
      placeholder="Search"
      className="h-10 flex-1 resize-none dark:border-secondary-400"
      prefix={<SearchIcon className="text-title" />}
      disabled={isSearching}
      onChange={handleChange}
      value={value}
      ref={inputRef}
      suffix={
        isSearching ? (
          <IconLoading className="mr-0 animate-spin" />
        ) : (
          results && (
            <div className="flex items-center gap-2">
              <span className="mr-2 text-sm leading-[22px]">
                {shownResultIndex + 1}/{results.length}
              </span>
              <IconButton
                icon={ChevronDownIcon}
                className="rotate-180"
                disabled={shownResultIndex <= 0}
                onClick={() => onPrev(results[shownResultIndex - 1])}
              />
              <IconButton
                icon={ChevronDownIcon}
                disabled={shownResultIndex === results.length - 1}
                onClick={() => onNext(results[shownResultIndex + 1])}
              />
            </div>
          )
        )
      }
    />
  )
}
